<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({ name: "UiTimePicker" });
</script>
<template>
    <!-- * 时间选择器 -->
    <div class="ui-time-picker" ref="container" v-bind="binds.container">
        <!-- * 选择器主体 -->
        <div class="ui-form-control" @click="show">
            <input class="ui-time-context" type="text" aria-name="start" v-bind="binds.start" readonly />
            <div class="ui-time-rect"></div>
            <input class="ui-time-context" type="text" aria-name="end" v-bind="binds.end" readonly />
        </div>

        <!-- * 候选列表 -->
        <Transition v-on="ons.candidates">
            <div class="ui-form-candidates" ref="candidates" v-if="visible" v-bind="binds.candidates">
                <div class="ui-form-candidate-container">
                    <div class="ui-time-picker-candidates">
                        <div class="ui-time-picker-candidate">
                            <div class="ui-candidate-name">{{ placeholder.start }}</div>
                            <div class="ui-candidate-controls">
                                <div class="ui-candidate-division"></div>
                                <ui-simplebar ref="sHourser" :height="210" trigger="Hover" @scroll="methods.scroll(0, sHourser, false)">
                                    <template v-for="(_, number) in 24">
                                        <div class="ui-candidate" :class="{ 'ui-active': sTime[0] == number }" @click="sHourser?.move(number * 30)">
                                            {{ number.toString().padStart(2, "0") }}
                                        </div>
                                    </template>
                                </ui-simplebar>

                                <ui-simplebar ref="sMinuteser" :height="210" trigger="Hover" @scroll="methods.scroll(1, sMinuteser, false)">
                                    <template v-for="(_, number) in 60">
                                        <div class="ui-candidate" :class="{ 'ui-active': sTime[1] == number }" @click="sMinuteser?.move(number * 30)">
                                            {{ number.toString().padStart(2, "0") }}
                                        </div>
                                    </template>
                                </ui-simplebar>

                                <template v-if="mode != 'minutes'">
                                    <ui-simplebar ref="sSecondser" :height="210" trigger="Hover" @scroll="methods.scroll(2, sSecondser, false)">
                                        <template v-for="(_, number) in 60">
                                            <div
                                                class="ui-candidate"
                                                :class="{ 'ui-active': sTime[2] == number }"
                                                @click="sSecondser?.move(number * 30)">
                                                {{ number.toString().padStart(2, "0") }}
                                            </div>
                                        </template>
                                    </ui-simplebar>
                                </template>
                            </div>
                        </div>

                        <div class="ui-time-picker-candidate">
                            <div class="ui-candidate-name">{{ placeholder.end }}</div>
                            <div class="ui-candidate-controls">
                                <div class="ui-candidate-division"></div>
                                <ui-simplebar ref="eHourser" :height="210" trigger="Hover" @scroll="methods.scroll(0, eHourser, true)">
                                    <template v-for="(_, number) in 24">
                                        <div class="ui-candidate" :class="{ 'ui-active': eTime[0] == number }" @click="eHourser?.move(number * 30)">
                                            {{ number.toString().padStart(2, "0") }}
                                        </div>
                                    </template>
                                </ui-simplebar>

                                <ui-simplebar ref="eMinuteser" :height="210" trigger="Hover" @scroll="methods.scroll(1, eMinuteser, true)">
                                    <template v-for="(_, number) in 60">
                                        <div class="ui-candidate" :class="{ 'ui-active': eTime[1] == number }" @click="eMinuteser?.move(number * 30)">
                                            {{ number.toString().padStart(2, "0") }}
                                        </div>
                                    </template>
                                </ui-simplebar>

                                <template v-if="mode != 'minutes'">
                                    <ui-simplebar ref="eSecondser" :height="210" trigger="Hover" @scroll="methods.scroll(2, eSecondser, true)">
                                        <template v-for="(_, number) in 60">
                                            <div
                                                class="ui-candidate"
                                                :class="{ 'ui-active': eTime[2] == number }"
                                                @click="eSecondser?.move(number * 30)">
                                                {{ number.toString().padStart(2, "0") }}
                                            </div>
                                        </template>
                                    </ui-simplebar>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script lang="ts" setup>
//* Vue
import { onBeforeUnmount } from "vue";
//* 组件引入
import UiSimplebar from "@various/components/simplebar";
//* 组件属性
import { UiTimePickerPropsOption, UiTimePickerEmits } from "./src/component";
import { useComposable } from "./src/composable";

//* 组件属性注册
const emits = defineEmits(UiTimePickerEmits);
const define = defineProps(UiTimePickerPropsOption);

//* 组合函数
const { ons, vars, refs, nodes, binds, methods, computeds } = useComposable(define, emits);
const { sTime, eTime } = computeds;
const { show, hidden } = methods;
const { sHourser, sMinuteser, sSecondser, eHourser, eMinuteser, eSecondser, candidates, container } = nodes;
const { visible } = refs;

//* 组件初始化
methods.init();

//* 组件卸载时释放内存
onBeforeUnmount(() => {
    vars.observer?.disconnect();
});

//* 组件属性导出
defineExpose({ show, hidden });
;
</script>
